import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/homePage',
    },
    {
        path: '/login',
        name: 'loginPage',
        component: () => import('../views/loginPage.vue')
    },
    {
        path: '/forgot',
        name: 'forgotPassword',
        component: () => import('../views/forgotPassword.vue')
    },
    {
        path: '/monitor',
        name: 'monitor',
        component: () => import('../views/monitor-screen/monitor.vue')
    },
    {
        path: '/homePage',
        name: 'homePage',
        redirect: '/device-management/deviceList',
        component: () => import('../views/home-view/homePage.vue'),
        children: [
            {
                path: '/companyManagement',
                name: 'companyManagement',
                meta: { tabName: '公司管理' },
                component: () => import('../views/user-center/companyManagement.vue')
            },
            {
                path: '/userManagement',
                name: 'userManagement',
                meta: { tabName: '用户管理' },
                component: () => import('../views/user-center/userManagement.vue')
            },
            {
                path: '/roleManagement',
                name: 'roleManagement',
                meta: { tabName: '角色管理' },
                component: () => import('../views/user-center/roleManagement.vue')
            },
            {
                path: '/device-management/deviceList',
                name: 'deviceList',
                meta: { tabName: '设备列表' },
                component: () => import('../views/device-list/deviceList.vue')
            },
            {
                path: '/device-management/deviceDetail',
                name: 'deviceDetail',
                meta: { tabName: '设备详情' },
                component: () => import('../views/device-list/deviceDetail.vue')
            },
            {
                path: '/systemMessage',
                name: 'systemMessage',
                meta: { tabName: '系统消息' },
                component: () => import('../views/message-center/systemMessage.vue')
            },
            {
                path: '/alarm-management/alarmList',
                name: 'alarmList',
                meta: { tabName: '告警列表' },
                component: () => import('../views/alarm-management/alarmList.vue')
            },
            {
                path: '/sendMessage',
                name: 'sendMessage',
                meta: { tabName: '发件箱' },
                component: () => import('../views/platform-settings/sendMessage.vue')
            },
            {
                path: '/pointSetting',
                name: 'pointSetting',
                meta: { tabName: '点位配置' },
                component: () => import('../views/platform-settings/pointSetting.vue')
            },
            {
                path: '/alarmCodeSetting',
                name: 'alarmCodeSetting',
                meta: { tabName: '告警码配置' },
                component: () => import('../views/platform-settings/alarmCodeSetting.vue')
            },
            {
                path: '/repairList',
                name: 'repairList',
                meta: { tabName: '报修列表' },
                component: () => import('../views/platform-settings/repairList.vue')
            },
            {
                path: '/emptyPermission',
                name: 'emptyPermission',
                meta: { tabName: '无权限' },
                component: () => import('../views/home-view/emptyPermission.vue')
            },
        ]

    }
]

const router = new VueRouter({
    mode: 'hash',
    base: import.meta.env.BASE_URL,
    routes
})

export default router
